// extracted by mini-css-extract-plugin
module.exports = {"tabs__content":"styles_tabs__content__0Ca_g","pulse":"styles_pulse__6eSy_","jump":"styles_jump__N8PQ5","wiggle":"styles_wiggle__0qJgZ"};